import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import ReactQuill from 'react-quill';
import { useDispatch } from 'react-redux';
import { IEditorProps } from './types';
import 'react-quill/dist/quill.snow.css';
import { useAtUserSearch } from '../../../../../../../../utils/atUserSearch.utils';
import { useSelect } from '../../../../../../../../utils/selector.utils';
import { userSelectors } from '../../../../../../../../app/resource/user/user.selectors';
import { updateTaskSimple } from '../../../../../../../../app/page/page-storage/tasks-simple/tasks-simple.actions';
import { MembersManyOnAtInput } from '../../../../../MembersManyOnAtInput';
import { Timeout } from 'react-number-format/types/types';

export const Editor: FunctionComponent<IEditorProps> = ({ task }) => {
  const dispatch = useDispatch();
  const [description, setDescription] = useState(task ? task.description : '');
  const [isTooLongError, setIsTooLongError] = useState(false);
  const { searchMember, onSelectUser, toggleClass, isActive } = useAtUserSearch({
    initText: task?.description,
    setText: setDescription,
  });
  const [timeoutId, setTimeoutId] = useState<Timeout | null>(null);
  const descriptionSentToApi = useRef<string | null>(null);

  const userIds = useSelect(userSelectors.selectResourceIds);

  useEffect(() => {
    if (task) {
      if (descriptionSentToApi.current === null) {
        setDescription(task?.description);
      } else {
        descriptionSentToApi.current = null;
      }
    }
  }, [task]);

  const handleTextChange = (newDescription: string) => {
    setDescription(newDescription);
    if (newDescription.length > 60000) {
      setIsTooLongError(true);
      return;
    }
    setIsTooLongError(false);

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    const newTimeoutId = setTimeout(() => {
      if (newDescription !== description) {
        saveTextToDatabase(newDescription);
      }
    }, 3000);

    setTimeoutId(newTimeoutId);
  };

  const saveTextToDatabase = (newDescription: string) => {
    if (task) {
      dispatch(
        updateTaskSimple(task.id, {
          description: newDescription,
        }),
      );
      descriptionSentToApi.current = newDescription;
    }
  };

  return (
    <>
      {isTooLongError && <div className="red">Description is too long</div>}
      <ReactQuill theme="snow" value={description} onChange={handleTextChange} />
      <div className={isActive ? 'dropdown opened' : 'dropdown'}>
        {isActive && (
          <MembersManyOnAtInput
            userIds={userIds}
            closeMenu={toggleClass}
            searchMember={searchMember}
            onSelectUser={onSelectUser}
            dropRight
          />
        )}
      </div>
    </>
  );
};
